// extracted by mini-css-extract-plugin
export default {"tableBody":"TableBody_tableBody__5bk13"};